import { EventClosePageProvider } from '@/context/FinancialPageContext';
import React from 'react';
import { EventCloseWrapper } from './EventCloseWrapper';

export const EventCloseScreen: React.FC = (): JSX.Element => (
  <EventClosePageProvider>
    <EventCloseWrapper />
  </EventClosePageProvider>
);
